<template>
  <div class="boxbgcolor api-configure">
    <!--左侧树形展示所有停车场-->
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right configure-right">
      <el-form ref="addOrEditForm" label-width="150px" :rules="rules" :model="payConfigure">
        <el-form-item label="商户代码" prop="merId">
          <el-input v-model="payConfigure.merId" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="经营类别" prop="category">
          <el-input v-model="payConfigure.category" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="商户柜台代码" prop="deviceinfo">
          <el-input v-model="payConfigure.deviceinfo" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="zkey" prop="zkey">
          <el-input v-model="payConfigure.zkey" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="dkey" prop="dkey">
          <el-input v-model="payConfigure.dkey"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="payConfigure.openFlag" label="是否启用" name></el-checkbox>
        </el-form-item>
      </el-form>
      <div class="submit">
        <el-button type="primary" size="medium" @click="addOrEdit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { bocConfigureOne, bocConfigureAddOrEdit } from "@/api/url";

import AreaTree from "@/page/commons/areaTree";

export default {
  data() {
    return {
      treeData: {
        parkingId: "",
      },
      fileList: [],
      payConfigure: {
        id: "",
        merId: "",
        category: "",
        deviceinfo: "",
        zkey: "",
        dkey: "",
        openFlag: false,
        parkingId: "",
      },
      rules: {
        merId: [{ required: true, message: "请填写商户代码", trigger: "blur" }],
        category: [
          { required: true, message: "请填写经营类别", trigger: "blur" },
        ],
        deviceinfo: [
          { required: true, message: "商户柜台代码", trigger: "blur" },
        ],
        zkey: [{ required: true, message: "请填写zkey", trigger: "blur" }],
        dkey: [{ required: true, message: "请填写dkey", trigger: "blur" }],
        // openFlag: [
        //     { required: true, message: '请填写微信公众号名称', trigger: 'blur' }
        // ]
      },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.resetForm();
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.payConfigureOne();
      } else {
        this.treeData.parkingId = "";
        this.payConfigure.merId = "";
        this.payConfigure.category = "";
        this.payConfigure.deviceinfo = "";
        this.payConfigure.zkey = "";
        this.payConfigure.dkey = "";
        this.payConfigure.openFlag = false;
        // this.$message({
        //         message: '请选择车场！',
        //         type: 'warning'
        // });
      }
      // if(node.level==2){
      // 	this.treeData.parkingId=data.parent.data.id;
      // 	this.treeData.areaId=node.id;
      // }
    },
    payConfigureOne() {
      this.$postRequest(bocConfigureOne(), {
        parkingId: this.treeData.parkingId,
      }).then((data) => {
        if (data.data) {
          // this.treeData.parkingId=data.data.parkingId;
          this.payConfigure.merId = data.data.merId;
          this.payConfigure.id = data.data.id;
          this.payConfigure.category = data.data.category;
          this.payConfigure.deviceinfo = data.data.deviceinfo;
          this.payConfigure.zkey = data.data.zkey;
          this.payConfigure.dkey = data.data.dkey;
          this.payConfigure.openFlag = data.data.openFlag == "y" ? true : false;
        } else {
          // this.treeData.parkingId='';
          this.payConfigure.merId = "";
          this.payConfigure.id = "";
          this.payConfigure.category = "";
          this.payConfigure.deviceinfo = "";
          this.payConfigure.zkey = "";
          this.payConfigure.dkey = "";
          this.payConfigure.openFlag = false;
        }
      });
      // console.log(this.payConfigure.openflag)
    },
    addOrEdit() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
        return;
      }
      this.$refs.addOrEditForm.validate((valid) => {
        if (valid) {
          if (this.payConfigure.id) {
            this.$postRequest(bocConfigureAddOrEdit(), {
              id: this.payConfigure.id,
              parkingId: this.treeData.parkingId, //停车场ID
              merId: this.payConfigure.merId,
              category: this.payConfigure.category,
              deviceinfo: this.payConfigure.deviceinfo,
              zkey: this.payConfigure.zkey,
              dkey: this.payConfigure.dkey,
              openFlag: this.payConfigure.openFlag ? "y" : "n",
            }).then((data) => {
              //提交后的操作
              if (data.status != 200) return this.$layer.msg(data.message);
              this.$notify({
                type: "success",
                title: "成功",
                message: "修改配置成功!",
              });
            });
          } else {
            this.$postRequest(bocConfigureAddOrEdit(), {
              parkingId: this.treeData.parkingId, //停车场ID
              merId: this.payConfigure.merId,
              category: this.payConfigure.category,
              deviceinfo: this.payConfigure.deviceinfo,
              zkey: this.payConfigure.zkey,
              dkey: this.payConfigure.dkey,
              openFlag: this.payConfigure.openFlag ? "y" : "n",
            }).then((data) => {
              if (data.status != 200) return this.$layer.msg(data.message);
              this.$notify({
                type: "success",
                title: "成功",
                message: "新增配置成功!",
              });
            });
          }
        } else {
        }
      });
    },
    isParkingIdEmpty() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
      }
    },
    resetForm() {
      this.$refs["addOrEditForm"].resetFields();
    },
  },
  computed: {},
  components: {
    AreaTree,
  },

  mounted: function () {},
};
</script>

<style scoped>
.submit {
  text-align: center;
}
</style>
<style>
.api-configure .el-form {
  width: 70%;
  margin: 0 auto;
  margin-top: 50px;
}
.api-configure .content-right .el-input__inner {
  border-radius: 5px;
  height: 50px;
  line-height: 50px;
}
.api-configure .el-form-item {
  margin-bottom: 30px;
}
.api-configure .el-form-item__label {
  height: 50px;
  line-height: 50px;
  color: #333 !important;
  font-weight: bold;
}
.submit .el-button {
  width: 200px;
  height: 50px;
}
.api-configure .el-checkbox__label {
  color: #333 !important;
  font-weight: bold;
}
</style>